
<template>
  <div id="app">
    <app-navbar></app-navbar>
    <transition name="navigating" mode="out-in">
      <router-view></router-view>
    </transition>
    <app-footer></app-footer>
  </div>

</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  components: {
    AppNavbar,
    AppFooter

  },
  computed: {
    tags () {
      return this.$store.state.event.tags
    }
  },
  created () {
    var me = this

    me.$store.dispatch('event/tags').then(response => {

    })
  }
  //,
  // watch: {
  //  '$route.params.confermaid': function (newVal, oldVal) {

  //    if (newVal && newVal!='') {

  //    }
  //  }
  // }
}
</script>
